"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseClient = void 0;
const HttpClient_1 = require("../HttpClient");
const index_1 = require("../Types/index");
class BaseClient {
    constructor(atlasEngineUrl, identity, socketIoManager) {
        this.baseUrl = `${index_1.restSettings.baseRoute}/v1`;
        const isValidAtlasEngineUrl = /^https?:\/\/.*/i;
        if (!isValidAtlasEngineUrl.test(atlasEngineUrl)) {
            throw new TypeError(`\`${atlasEngineUrl}\` is not a valid http(s) URL!`);
        }
        this.atlasEngineUrl = atlasEngineUrl;
        this.identity = identity;
        this.socketIoManager = socketIoManager;
        this.httpClient = new HttpClient_1.HttpClient(this.atlasEngineUrl);
    }
    /**
     * Gets the url of the engine that this client is communicating with.
     */
    getEngineUrl() {
        return this.atlasEngineUrl;
    }
    disconnectSocket(identity) {
        if (this.socketIoManager) {
            this.socketIoManager.disconnectSocket(identity);
        }
    }
    dispose() {
        if (this.socketIoManager) {
            this.socketIoManager.dispose();
        }
    }
    buildUrl(url, offset = 0, limit = 0, query, sortSettings) {
        let finalUrl = `${this.baseUrl}${url}`;
        if (query) {
            finalUrl = this.encodeQueryAndAddParametersToUrl(finalUrl, query);
        }
        if (sortSettings) {
            const encodedSortSettings = encodeURIComponent(JSON.stringify(sortSettings));
            finalUrl = this.addParameterToUrl(finalUrl, 'sortSettings', encodedSortSettings);
        }
        if (offset > 0) {
            finalUrl = this.addParameterToUrl(finalUrl, 'offset', offset);
        }
        if (limit > 0) {
            finalUrl = this.addParameterToUrl(finalUrl, 'limit', limit);
        }
        return finalUrl;
    }
    createRequestAuthHeaders(identity) {
        const identityToUse = identity !== null && identity !== void 0 ? identity : this.identity;
        const requestAuthHeaders = {
            headers: {
                Authorization: `Bearer ${identityToUse.token}`,
            },
        };
        return requestAuthHeaders;
    }
    createSocketIoSubscription(route, callback, subscribeOnce, identity) {
        const identityToUse = identity !== null && identity !== void 0 ? identity : this.identity;
        return this.socketIoManager.createSocketIoSubscription(identityToUse, route, callback, subscribeOnce);
    }
    removeSocketIoSubscription(identity, subscription) {
        const identityToUse = identity !== null && identity !== void 0 ? identity : this.identity;
        this.socketIoManager.removeSocketIoSubscription(identityToUse, subscription);
    }
    addParameterToUrl(url, parameterName, parameterValue) {
        if (url.indexOf('?') > 0) {
            return `${url}&${parameterName}=${parameterValue}`;
        }
        return `${url}?${parameterName}=${parameterValue}`;
    }
    encodeQueryAndAddParametersToUrl(url, query) {
        const parameters = Object.keys(query);
        for (const paramName of parameters) {
            const paramValue = query[paramName];
            if (paramValue === undefined) {
                continue;
            }
            let encodedParameter;
            if (Array.isArray(paramValue)) {
                encodedParameter = paramValue.map(this.encodeValue).join(',');
            }
            else {
                encodedParameter = this.encodeValue(paramValue);
            }
            url = this.addParameterToUrl(url, paramName, encodedParameter);
        }
        return url;
    }
    encodeValue(value) {
        let encodedParameter;
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            encodedParameter = encodeURIComponent(value);
        }
        else if (value instanceof Date) {
            encodedParameter = encodeURIComponent(value.toISOString());
        }
        else {
            const stringifiedValue = JSON.stringify(value);
            encodedParameter = encodeURIComponent(stringifiedValue);
        }
        return encodedParameter;
    }
}
exports.BaseClient = BaseClient;
//# sourceMappingURL=BaseClient.js.map